import type { AnyModuleOptions } from './types/external'

export const DEFAULT_ANY_MODULE_OPTIONS = {
  version: 1
} satisfies AnyModuleOptions
